import Vue from 'vue';
import VueRellax from 'vue-rellax';

export default {
    init() {
        Vue.use(VueRellax);
    },
};
